import { render, staticRenderFns } from "./ShipmentProtocolsList.view.vue?vue&type=template&id=04cccee5&"
import script from "./ShipmentProtocolsList.view.vue?vue&type=script&lang=js&"
export * from "./ShipmentProtocolsList.view.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentProtocolsList.view.vue?vue&type=style&index=0&id=04cccee5&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VContainer,VIcon,VSpacer})
